async function updateVariant(variantId) {
  const url = new URL(window.location.href);
  url.searchParams.set('variant', variantId);

  url.searchParams.set('sections', 'main-product');
  const { 'main-product': mainProduct } = await fetch(url.href).then((res) => res.json());

  const mainProductDocument = new DOMParser().parseFromString(mainProduct, 'text/html');

  url.searchParams.delete('sections');
  window.history.replaceState({}, '', url.href);

  document.getElementById('product-description').innerHTML =
    mainProductDocument.getElementById('product-description').innerHTML;
}

class AddToBag extends HTMLElement {
  variantId = null;
  quantity = 1;
  cartAddUrl = null;

  constructor() {
    super();

    this.variantId = this.dataset.variantId;
    this.cartAddUrl = this.dataset.cartAddUrl;

    this.addEventListener('click', this.onClick.bind(this));
  }

  async onClick() {
    const newCartItem = document.getElementById('cart-item-template').content.cloneNode(true);
    const existingCartItem = document.querySelector(`#cart-items [data-variant-id="${this.variantId}"]`);
    if (existingCartItem) {
      existingCartItem.replaceWith(newCartItem);
    } else {
      document.getElementById('cart-items').appendChild(newCartItem);
    }
    document.getElementById('cart').showModal();

    const res = await fetch(this.cartAddUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: `application/json`,
      },
      body: JSON.stringify({
        items: [
          {
            id: this.variantId,
            quantity: this.quantity,
          },
        ],
        sections: 'cart',
      }),
    });

    if (!res.ok) {
      // const toast = document.getElementById('add-to-cart-error-template').content.cloneNode(true);
      // toast.querySelector('p').innerText = (await res.json()).errors;
      // document.getElementById('product-toast-container').appendChild(toast);
      return;
    }

    // const toast = document.getElementById('added-to-cart-template').content.cloneNode(true);
    // document.getElementById('product-toast-container').appendChild(toast);

    const { sections } = await res.json();
    const newDocument = new DOMParser().parseFromString(sections['cart'], 'text/html');

    const cart = document.querySelector('#cart');
    if (cart) {
      cart.innerHTML = newDocument.querySelector('#cart').innerHTML;
    }

    const cartItemCount = newDocument.querySelector('#cart-quantity-template').innerHTML;
    for (const element of document.querySelectorAll('.cart-quantity')) {
      element.innerText = cartItemCount;
    }
    for (const element of document.querySelectorAll('.cart-quantity-dot')) {
      element.innerText = cartItemCount;
      if (cartItemCount === '0') {
        element.classList.add('hidden');
      } else {
        element.classList.remove('hidden');
      }
    }
  }
}
customElements.define('add-to-bag', AddToBag);
